import axios from 'axios';

export const loadSettings = async (tenantId) => {
    const { data } = await axios.get(`${window.__KEAP__.VUE_APP_PACKAGING_SERVICE_URL}/api/v2/settings/tenant/${tenantId}`);

    return data;
};
